const translate = {
    portugues: {
        title: 'Painel de Downloads',
        subTitle: 'Informe seus dados de acesso abaixo.',
        myVideos: 'Meus Videos',
        addCredits: 'Adicionar Créditos',
        myHistory: 'Meu Histórico ',
        labelVideosDown: 'Confira abaixo seu histórico de compras:',
        subLabelVideosDown: 'Aqui você pode conferir os seus vídeos',
        totalDownloads: 'Total de Downloads',
        totalCredits: 'Créditos Totais',
        hello: 'Olá',
        sweetDo: 'escolha o que deseja fazer',
        orderStatus: 'Status do crédito',
        orderPlanName: 'Plano',
        orderMethodName: 'Forma de pagamento',
        orderValue: 'Valor',
        orderDate: 'Data',
    },
    ingles: {
        title: 'Painel de Downloads',
        subTitle: 'Enter your access details below.',
        myVideos: 'My Videos',
        addCredits: 'Add credits',
        myHistory: 'My History',
        labelVideosDown: 'Check your purchase history below:',
        subLabelVideosDown: 'Here you can check out his videos',
        totalDownloads: 'Total Downloads',
        totalCredits: 'Total Credits',
        hello: 'Hello',
        sweetDo: 'choose what you want to do',
        orderStatus: 'Credit Status',
        orderPlanName: 'Plan',
        orderMethodName: 'Payment Method',
        orderValue: 'Value',
        orderDate: 'Date',
    }
}

export default translate
